import apiClient from '../client';
import type { LoginResponse, User, DashboardSummary } from '../../types';

// ─── Auth Endpoints ────────────────────────────────────────────────────────────

export const auth = {
  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>(
      '/auth/login',
      { email, password }
    );
    return response.data;
  },

  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/auth/me');
    return response.data;
  },

  switchCompany: async (companyId: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>(
      '/auth/switch-company',
      { company_id: companyId }
    );
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout');
  },

  refresh: async (): Promise<{ access_token: string }> => {
    const response = await apiClient.post<{ access_token: string }>('/auth/refresh');
    return response.data;
  },
};

// ─── Dashboard Summary Endpoint ────────────────────────────────────────────────

export const dashboard = {
  getSummary: async (year: number): Promise<DashboardSummary> => {
    const response = await apiClient.get<DashboardSummary>(
      '/dashboard/summary',
      { params: { year } }
    );
    return response.data;
  },
};
